export default {
  CLEAR: "clear",
  EXPIRED: "expired",
};
